import { render } from "./menuBarToolTip.vue?vue&type=template&id=0003a88b&scoped=true&ts=true"
import script from "./menuBarToolTip.vue?vue&type=script&lang=ts"
export * from "./menuBarToolTip.vue?vue&type=script&lang=ts"

import "./menuBarToolTip.vue?vue&type=style&index=0&id=0003a88b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0003a88b"]])

export default __exports__